// third-party
import { FormattedMessage } from "react-intl";
import {
  LocusAnalyticsDashboardsIcon,
  LocusReportsIcon,
} from "../assets/icons/LocusIcons.js";
import {
  CROSS_SITE_VIEWER,
  LOCUS_ASSET_MANAGER,
  LOCUS_TENANT,
  VIEWER,
} from "../utils/constants/user";
import * as React from "react";

// ==============================|| APPLICATION MENU ITEMS ||============================== //
/** @type {LocusMenuGroup} */
const analytics = {
  id: "analytics",
  title: <FormattedMessage id="analytics" />,
  type: "group",
  view: ["locus", "site"],
  children: [
    {
      id: "dashboards",
      title: <FormattedMessage id="dashboards" />,
      type: "item",
      icon: LocusAnalyticsDashboardsIcon,
      url: "dashboards?site=:siteId",
      allowedGroups: [LOCUS_TENANT, CROSS_SITE_VIEWER, VIEWER],
      view: ["site"],
    },
    {
      id: "reports",
      title: <FormattedMessage id="reports" />,
      type: "item",
      icon: LocusReportsIcon,
      url: "reports?site=:siteId",
      allowedGroups: [LOCUS_TENANT, CROSS_SITE_VIEWER, VIEWER],
      view: ["site"],
    },
    {
      id: "reports-tools",
      title: <FormattedMessage id="reports" />,
      type: "collapse",
      icon: LocusReportsIcon,
      view: ["locus"],
      children: [
        {
          id: "robot-assets",
          title: <FormattedMessage id="bot-assets" />,
          type: "item",
          url: "reports/robot-assets",
          breadcrumbs: true,
          view: ["locus"],
          allowedGroups: [LOCUS_ASSET_MANAGER],
        },
        {
          id: "global-site-health",
          title: <FormattedMessage id="global-site-health" />,
          type: "item",
          url: "reports/global-site-health",
          breadcrumbs: true,
          view: ["locus"],
          allowedGroups: [LOCUS_TENANT],
        },
      ],
    },
  ],
};

export default analytics;
